import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_order_approvers: { message: "idle" },
};

export const tenant_update_order_approvers_Slice = createSlice({
 name: "tenant_update_order_approvers",
 initialState,
 reducers: {
  success_tenant_update_order_approvers: (state, action) => {
   state.tenant_update_order_approvers = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_order_approvers: (state, action) => {
   state.tenant_update_order_approvers = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_order_approvers: (state) => {
   state.tenant_update_order_approvers = { status: app_consts.IDLE };
  },
  loading_tenant_update_order_approvers: (state) => {
   state.tenant_update_order_approvers = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_order_approvers, fail_tenant_update_order_approvers, reset_tenant_update_order_approvers, loading_tenant_update_order_approvers } = tenant_update_order_approvers_Slice.actions;

export default tenant_update_order_approvers_Slice.reducer;